import { notif } from "../RTDNotifV2";
export class GenericDataSet {
    constructor(datasetName) {
        this.datasetName = null;
        this.datasetName = datasetName;
    }
    async subscribe(successCallback, errorCallback, connectionCallback) {
        notif.listener({
            datasetName: this.datasetName,
            subscriptionCallback: (err, data) => {
                // eslint-disable-next-line no-console
                console.log(`Subscription ${this.datasetName} Callback ${data} | timestamp=${new Date()}, UTC=${new Date().toUTCString()}`);
                if (err) {
                    errorCallback(err);
                }
                else {
                    this.dataset = data;
                    successCallback(data);
                }
            },
            updateCallback: (err, delta) => {
                //TODO: synchronize data
                //console.log(`updateCallback ${this.datasetName} Callback`);
                if (err) {
                    errorCallback(err);
                }
                else {
                    this.sync(delta);
                    successCallback(this.dataset, delta);
                }
            },
            connectionStatusCallback: (isConnected) => {
                if (isConnected !== null) {
                    connectionCallback(isConnected);
                }
            }
        });
    }
    sync(delta) {
        const deltaKeysMap = {};
        const deleteKeysList = [];
        const dataSetKeyMap = {};
        delta.datasetValues.forEach((datasetvalue) => {
            if (datasetvalue.operation === "DELETE") {
                deleteKeysList.push(datasetvalue.key);
            }
            else {
                // @ts-expect-error Tech debt (fix me CX-16279) - error enabled as part of CX-21272
                deltaKeysMap[datasetvalue.key] = datasetvalue;
            }
        });
        this.dataset?.datasetValues.forEach((datasetvalue) => {
            if (!deleteKeysList.includes(datasetvalue.key)) {
                // @ts-expect-error Tech debt (fix me CX-16279) - error enabled as part of CX-21272
                dataSetKeyMap[datasetvalue.key] = datasetvalue;
            }
        });
        const combinedDataSet = { ...dataSetKeyMap, ...deltaKeysMap };
        if (this.dataset) {
            this.dataset.datasetValues = Object.values(combinedDataSet);
            this.dataset.type = delta.type;
        }
        else {
            this.dataset = { ...delta, datasetValues: Object.values(combinedDataSet) };
        }
    }
}
